import { Text } from "@ecco/ui/text";
import { Flex } from "@ecco/ui/flex";
import { CloseButton } from "@ecco/ui/close-button";

type Props = {
    title: string;
    description: string;
    onClose: () => void;
};

export const Notification = ({ description, onClose, title }: Props) => {
    return (
        <Flex justifyContent="space-between" color="white" p={4} bg="gray.900" mb={6}>
            <Flex direction="column" gap={2}>
                <Text fontWeight="bold">{title}</Text>
                <Text>{description}</Text>
            </Flex>
            <CloseButton onClick={onClose} />
        </Flex>
    );
};
